import { Collapse } from "element-ui";
import ServiceInformation from '../ServiceInformation/ServiceInformation.vue'

export default {
    components: { ServiceInformation},
    name: 'detailsPage',
    data() {
        return {
  
            // 产品id
            id:'',
            //获取试题的id
            testID:'',
            //判断时长字段是否存在
            isRate:true,
            //学习按钮的字
            studyText:'',
            //我的订单的商品id
            orderGoodsId:'',
            //总课时
            sumClass:0,
            //课程隐藏
            // huodong:false,
            // ziyuan:false,
            //已完成课时
            continueClass:{},
            finishedClass:0,

            //详细信息
            classDetails: {},
            //项目信息
            projectDetails: {},
            // resources: [{
            //     name: '',
            //     items: [{
            //         name: '',
            //         resources: []
            //     }]
            // }],
            //UIkit
            tips: '',
            //项目任务
            assignment: [],
            // 折叠面板
            activeNames: [],
            //项目大纲数组
            outline:[],
           
        }
    },
    methods: {
        //树形控件函数
        handleChange(val) {
            // // console.log(val);
        },
       
 

    //获取产品详情
    getresources(){
        let me = this
       return (this.$post('products/get',{token: this.$store.state.id, id: me.id})
            .then(res=>{
                this.classDetails = res.data.result
                this.$post('projects/search',{
                    token: this.$store.state.id, 
                    id: res.data.result.project_id
                }).then(res=>{
                    this.projectDetails = res.data.result
                    this.getoutline()//获取项目大纲
                })
            })
        );
    },
    //展开目录函数
    zhankai(){
        for(let i=0 ;i< this.outline.length;i++){
            for(let j=0 ;j< this.outline[i].task_activities.length;j++){
                for(let z=0 ;z< this.outline[i].task_activities[j].resources.length;z++){
                
                    this.activeNames.push(i+'-'+j+'-'+z)
                }
                this.activeNames.push(i+'-'+j)
            }
            this.activeNames.push(i+'')
        }
    },

   //添加购物车
   addShoppingCart() {
       let me = this
        this.$post('shopping_cart/search', { token: this.$store.state.id, offset: '0', length: '999' ,shop_id:this.$store.state.store.id}).then(res => {
            let arr = [];
            for (let val of res.data.result.data) {
                arr.push(Number.parseInt(val.product_id));
            }
            return arr;
        }).then(arr => {
            if (arr.indexOf(Number.parseInt(me.id)) == -1) {
                this.$post('shopping_cart/create', { product_id: me.id, token: this.$store.state.id }).then(res => {
                    if (res.data.status == 'success') {
                        this.$store.state.shopNum += 1;
                        this.tips = '商品添加成功';
                        UIkit.modal(document.querySelector('#modal-buy')).show();
                    }
                });
            } else {
                this.tips = '购物车已经存在该商品，请勿重复添加';
                UIkit.modal(document.querySelector('#modal-buy')).show();
            }
        })

    },
    //判断是否已经购买过该课程
    byNow: function (productId, price) {
        if (Number.parseFloat(price) == 0) {
            this.$post('orders/create', {
                token: this.$store.state.id,
                products: '[' + productId + ']',
                pay_type: 1,
                shop_id: this.$store.state.store.id
            }).then(res => {
                if (res.data.status == 'success') {
                    return res.data.result;
                }
            }).then(id => {
                let time = this.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
                this.$post('orders/cancel', { id: id, token: this.$store.state.id, state: '2', pay_date: time }).then(res => {
                    if (res.data.status == 'success') {
                        UIkit.modal(document.querySelector('#modal-free-class')).show();
                        this.$router.push({
                            path: '/personalcenter',
                        });
                    }
                })
            })

        } else {
            let commodityList = [];
            let totalprices = price;
            commodityList.push(productId)
            this.$router.push({
                path: '/pay',
                query: {
                    commodityList: JSON.stringify(commodityList),
                    totalprices: totalprices,
                }
            });
        }
      },

    //跳转到项目式学习页
    tolessonstudy(id){
        this.$router.push({
            path: '/lessonstudy',
            query: {
                id:id
            }
        })
    },

    //跳转到云课程详情
    toclassdetails(id){
        this.$router.push({
            path: '/classdetails',
            query: {
                id:id
            }
        })
    },

        //跳转到云课程学习页
    toclassstudy(id){
        this.$router.push({
            path: '/classstudy',
            query: {
                id:id
            }
        })
    },

    //    // 判断课程是否购买
    //    judgeBuy(){
    //     let BZ //是否购买变量
    //     let is_project
    //     this.$post('users/isPay', {//返回true则没有购买，返回false就说明已经购买
    //         token: this.$store.state.id,
    //         product_id: this.id,
    //     }).then(res => { 
    //     //   // console.log('是否购买',res.data.result)
    //       BZ = res.data.result
    //       this.$post('products/get', { //返回is_project =1 是项目式  0 是云课程
    //             token: this.$store.state.id,
    //             id: this.id,
    //         }).then(res => {
    //             // // console.log('判断课程类型',res.data.result.is_project)
    //             is_project = res.data.result.is_project
    //             if(BZ){//没有购买
    //                 if(is_project == 1 ){
    //                     this.getresources()  //获取信息数据
    //                 }else{
    //                     this.toclassdetails(this.id)//跳转至云课程详情页
    //                 }
    //             }else{
    //                 if(is_project == 1 ){
    //                      this.tolessonstudy(this.id)//跳转至项目式学习情页
                   
    //                 }else{
    //                     this.toclassstudy(id)(this.id)//跳转至云课程学习页
    //                 }
                    
    //             }
    //         })
    //     })
    //   },

    //查询项目大纲
    getoutline(){
        this.$post('project_tasks/search_group_by_task', {
            token: this.$store.state.id,
            offset:0 , 
            length: 100, 
            project_id:  this.projectDetails.id 
        }).then(res => {
        this.outline = res.data.result.data.map((res)=>{
                for(let i=0;i<res.task_activities.length;i++){
                    let arr = JSON.parse(res.task_activities[i].resources)
                    res.task_activities[i].resources = arr
                }  
                return res
        })
        this.zhankai()//配置展开数组
        // // console.log('项目大纲',this.outline )
        })
      },
        
    },
    mounted(){ 
        // this.judgeBuy()//判断跳转 
        
        // this.getoutline();
        
        // this.zhankai();

    },
    created(){
        
        this.id = this.$route.query.id //页面跳转传递id
        this.getresources();
        // // console.log('产品id：',this.id)
    },
}